import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Login from './Login';
import Register from './Register';
import ConfirmPassword from './ResetPassword/ConfirmPassword';
import SendEmail from './ResetPassword/SendEmail';
import { AuthPageWrapper, BottomElipse, PageContainer, TopElipse } from './styled';

function Auth() {
	return (
		<AuthPageWrapper>
			<PageContainer>
				<Routes>
					<Route path="/register" element={<Register />} />
					<Route path="/reset-password" element={<SendEmail />} />
					<Route path="/reset-password/:resetPasswordToken" element={<ConfirmPassword />} />
					<Route path="*" element={<Login />} />
				</Routes>
			</PageContainer>
			<TopElipse />
			<BottomElipse />
		</AuthPageWrapper>
	);
}

export default Auth;
